import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './show-more-button.module.scss';

interface ShowMoreButtonProps {
  text: string;
  maxChars: number;
}

export const ShowMoreButton = ({ text, maxChars }: ShowMoreButtonProps) => {
  const { t } = useTranslation('common');
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => setIsExpanded((prev) => !prev);

  const truncatedText = text.length > maxChars ? text.substring(0, maxChars).trim() + '…' : text;

  return (
    <p className={styles.showMoreButtonWrapper}>
      {isExpanded ? text : truncatedText}{' '}
      {text.length > maxChars && (
        <button type="button" className={styles.showMoreButton} onClick={toggleExpanded}>
          {isExpanded ? t('actions.showLess') : t('actions.showMore')}
        </button>
      )}
    </p>
  );
};
